import { axios } from '@/plugins/axios'

export class Enroll {
  static enrollCourseUnit(courseId, unitId) {
    return axios.get('/enroll/course-unit-data', {
      params: {
        courseId: courseId,
        unitId: unitId
      }
    })
  }

  static enrollVerifyCPF(cpf) {
    return axios.get('/enroll/verify-cpf', {
      params: {
        cpf: cpf
      }
    })
  }

  static enrollVerifyCoupon(coupon, courseId, unitId) {
    return axios.get('/enroll/verify-coupon', {
      params: {
        coupon: coupon,
        course_id: courseId,
        unit_id: unitId
      }
    })
  }

  static enrollStoreEnrollment(data) {
    return axios.post('/enroll/store-enrollment', data)
  }

  static enrollMakePayment(data) {
    return axios.post('/enroll/make-payment', data)
  }

  static resetEnrollmentPayment(data) {
    return axios.post('/enroll/reset-enrollment-payment', data)
  }

  static enrollStudent(courseId, teachingUnit, teachingPlatform, studentData) {
    return axios.post('/enrollment', {
      courseId,
      teachingUnit,
      teachingPlatform,
      studentData
    })
  }

  static getPersonDataIfExists (cpf) {
    return axios.get('/enroll/student', {
      params: {
        cpf: cpf
      }
    })
  }

  static getTeachingUnitPlatforms (teachingUnit) {
    return axios.get('/enroll/teaching-platforms/', {
      params: {
        teachingUnit: teachingUnit
      }
    })
  }
}
